import { Button, Image, Result, Typography } from 'antd';

import { FormAddButton, StyledModal } from 'common/components';

import {
  CreditCardIframe,
  CreditCardIframeModal,
} from 'pages/company-profile/components/tabs/billing-new/MemberCardInformation';

import { RIVIRBillingReview } from '../ixone-credit-card';

import { useVisibleModal } from 'hooks';

import WarnIcon from 'common/components/dialog-function/WarnIcon';
import creditCardImage from 'assets/credit-card.png';

export const ActiveProductMessage = () => {
  return <Message>to activate the product.</Message>;
};

export const IXOneMessage = () => {
  return (
    <Message>
      to send <Message strong>IX-ONE Capture.</Message>
    </Message>
  );
};

const COD_PAYMENT_TYPE_VIEW_MESSAGE = {
  activeProduct: <ActiveProductMessage />,
  sendIXOneCapture: <IXOneMessage />,
};

export const ReadyToChargeSection = ({ fee, children, typeView }) => {
  return (
    <div style={{ textAlign: 'center', marginTop: 4 }}>
      <Message>
        Your payment term is <Message strong>Cash on Delivery (COD)</Message>
        <br />A charge of <Message strong>${fee}</Message>{' '}
        <Message>will be applied immediately </Message>
        <Message>{COD_PAYMENT_TYPE_VIEW_MESSAGE[typeView]}</Message>
      </Message>
      {children}
    </div>
  );
};

const Message = ({ children, style, ...rest }) => {
  return (
    <Typography.Text
      style={{
        color: '#6c757d',
        fontSize: 16,
        ...style,
      }}
      {...rest}
    >
      {children}
    </Typography.Text>
  );
};

export const CreditCardInfo = ({ memberCard }) => {
  return <Message strong>{memberCard?.nameAlias ?? 'xxxx card'}</Message>;
};

export const CreditCardSection = ({ children }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 1.8,
      }}
    >
      <Image src={creditCardImage} width={60} height={60} preview={false} />
      <div style={{ paddingTop: 8, paddingLeft: 2 }}>{children}</div>
    </div>
  );
};

export const MissingCardSection = ({ children }) => {
  return (
    <div style={{ textAlign: 'center', marginTop: 4 }}>
      <Message>
        Your payment term is <Message strong>Cash on Delivery (COD), </Message>
      </Message>
      <Message>
        but we require a credit card to execute this action. Please add a credit
        card to proceed.
      </Message>
      {children}
    </div>
  );
};

export const BlockChargeSection = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: 4 }}>
      <Result
        status='403'
        title={
          <Message strong style={{ fontSize: 14 }}>
            Sorry, you do not have permission to execute this action.
          </Message>
        }
      />
    </div>
  );
};

export const ModalConfirm = (props) => {
  const { children, hideWarningIcon = false, ...rest } = props;

  return (
    <StyledModal
      title={null}
      width={540}
      bodyStyle={{ paddingTop: 24 }}
      okText='Submit'
      {...rest}
    >
      {hideWarningIcon ? null : <WarnIcon />}
      {children}
    </StyledModal>
  );
};

export const AddBank = (props) => {
  return <FormAddButton text='Add Bank Card' ghost {...props} />;
};

export const ContentConfirmRequest = () => {
  const [
    visibleReviewBilling,
    { onModal: onModalReviewBilling, offModal: offModalReviewBilling },
  ] = useVisibleModal();

  return (
    <>
      <Button type='link' block>
        <Typography.Text strong underline onClick={onModalReviewBilling}>
          Credit Card Terms & Conditions
        </Typography.Text>
      </Button>

      {visibleReviewBilling && (
        <RIVIRBillingReview
          visible={visibleReviewBilling}
          onCancel={offModalReviewBilling}
        />
      )}
    </>
  );
};

export const CODReadyToChargeSection = ReadyToChargeSection;
export const CODCreditCardInfo = CreditCardInfo;
export const CODCreditCardSection = CreditCardSection;
export const CODMissingCardSection = MissingCardSection;
export const CODBlockChargeSection = BlockChargeSection;
export const CODModalConfirm = ModalConfirm;
export const CODMessage = Message;
export const CODAddBank = AddBank;

export { CreditCardIframe, CreditCardIframeModal };
